import React from 'react'
import PrivacyPolicyComponent from '../components/privacy_policy/index'

const PrivacyPolicy = () => {
    return (
        <PrivacyPolicyComponent/>
    )
}

export default PrivacyPolicy